const C = {
  greenDark: "#047857",
  body: "#374151",
  line: "#E5E7EB",
};

export default function TabbarItem({ currentTab, item, onClick }) {
  const active = currentTab === item;
  return (
    <button
      type="button"
      onClick={() => onClick()}
      style={{
        padding: "8px 18px",
        borderRadius: 9999,
        fontSize: 14,
        fontWeight: active ? 700 : 500,
        color: active ? "#fff" : C.body,
        background: active ? C.greenDark : "#fff",
        border: `1px solid ${active ? C.greenDark : C.line}`,
        cursor: "pointer",
        transition: "all 0.15s ease",
        whiteSpace: "nowrap",
      }}
    >
      {item}
    </button>
  );
}
